var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "check__container",
      class: { check__text: _vm.type == "text" },
      style: _vm.mainStyle
    },
    [
      _vm.label.before
        ? _c(
            "label",
            { class: { active: !_vm.checked }, attrs: { for: _vm.id } },
            [_vm._v(_vm._s(_vm.label.before))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.checked,
            expression: "checked"
          }
        ],
        class: { check: _vm.type == "simple" },
        style: _vm.ckeckThem,
        attrs: { id: _vm.id, type: "checkbox" },
        domProps: {
          checked: _vm.checked,
          checked: Array.isArray(_vm.checked)
            ? _vm._i(_vm.checked, null) > -1
            : _vm.checked
        },
        on: {
          change: [
            function($event) {
              var $$a = _vm.checked,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.checked = $$c
              }
            },
            function($event) {
              return _vm.changed($event)
            }
          ]
        }
      }),
      _vm._v(" "),
      _vm.label.after
        ? _c(
            "label",
            { class: { active: _vm.checked }, attrs: { for: _vm.id } },
            [_vm._v(_vm._s(_vm.label.after))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0dee6900", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dee6900","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Toggle.vue
// module id = null
// module chunks = 